import { useEffect, useRef } from 'react';




const RESIZE_DEBOUNCE_MS = 100;

export const measureImgBox = img => ({
    width: img.offsetWidth,
    height: img.offsetHeight,
    borderRadius: window.getComputedStyle(img).borderRadius
});

export const captureGifFreezeFrame = (img, canvas) => {
    const ctx = canvas && canvas.getContext && canvas.getContext('2d');
    if (!img || !ctx) return null;

    
    const dpr = window.devicePixelRatio || 1;
    canvas.width = img.offsetWidth * dpr;
    canvas.height = img.offsetHeight * dpr;
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

    return measureImgBox(img);
};

export const useDebouncedResizeListener = (handler, enabled) => {
    
    const handlerRef = useRef(handler);
    handlerRef.current = handler;

    useEffect(() => {
        if (!enabled) return undefined;
        let timeoutId;
        const onResize = () => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => handlerRef.current(), RESIZE_DEBOUNCE_MS);
        };
        window.addEventListener('resize', onResize);
        return () => {
            clearTimeout(timeoutId);
            window.removeEventListener('resize', onResize);
        };
    }, [enabled]);
};
